export default function getEnv(name: string): string | undefined {
  let raw: string | undefined;
  if (process.env.NODE_ENV == "production") {
    const portal = (window as any).envPortal;
    if (portal && typeof portal == "object") {
      const v = portal[name];
      raw = v != null ? String(v) : undefined;
    }
  } else {
    raw = process.env[name] as string | undefined;
  }
  if (raw == null || raw == "") {
    return undefined;
  }
  return raw;
}
